// React basic and bootstrap
import React, { Component } from "react";
import { Link } from "react-router-dom";

import { Container, Row, Col, UncontrolledTooltip, List, ListInlineItem, Button } from "reactstrap";

import theme from './index.css'
import buttons from './buttons.css'
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment theme={theme}>
        <section className="bg-gradient-primary ">
          <Row className="justify-content-center d-flex">
              <Col lg={12} md={12} className="text-center">
              <div className="title-heading d-flex justify-content-center">
               <h1 className="heading main-title mt-4 mb-3">
               Machine Learning for NFT Space &nbsp;
               </h1>
              </div>
               <a theme={buttons} href="#style-transfer" className="btn btn-two mt-5 cyan large ">Try Demo</a>
                  
              </Col>
              </Row>
        </section>
        <section
          className="bg-half-170 home-wrapper border-bottom d-table w-100"
          id="home"
        >
          <Container className="py-4 my-4">
            <Row className="align-items-center d-flex justify-content-center">
              <Col lg={4} md={4} xs={12} className='py-5'>
                <div className="title-heading mb-4" style={{'min-height':'60px'}}>
                  <h3>NFT Style Transfer</h3>
                </div>
                <div class="feature-body">
                <p>
                  Produce new NFTs which inherit from their parent NFT styles and content. 
                  Our product leverages state-of-the-art ML models to generate high-quality images
                </p>
                </div>
              </Col>
               <Col lg={4} md={4} xs={12}>
                <div className="title-heading mb-4" style={{'min-height':'60px'}}>
                  <h3>Experiment with ML features</h3>
                </div>
                <div class="feature-body">
                <p>
                  Machine Learning can fuel a form of unsupervised art. Experiment with ML model hyperparameters and designs 
                  to create innovative NFTs powered by machine imagination
                </p>
                </div>
              </Col>
              <Col lg={4} md={4} xs={12}>
                <div className="title-heading mb-4" style={{'min-height':'60px'}}>
                  <h3>Mint new NFTs on blockchain</h3>
                </div>
                <div class="feature-body">
                <p>
                  Minted NFTs persist unique data about ML parameters and settings used to create them on blockchain. 
                  NFTs inherit rarity and unique properties of their parent NFTs 
                </p>
                </div>
              </Col>

            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Home;